import React from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import './style.scss'

const CreateCampaign = () => {
    const navigate = useNavigate()

    const handleManualBuild = () => {
        navigate('/campaign/create')
    }

    const handleAiBuild = () => {
        navigate('/campaign/create/ai-auto')
    }

    return (
        <div className="page-content">
            <div className="page-content-inner page-spacing">
                <div className="new-campaign-creation-mode">
                    <div className='new-campaign-creation-mode-header'>
                        <div className="d-flex flex-column justify-content-center align-items-center gap-2">
                            <h1 className="new-campaign-creation-mode-title">How do you want to build your campaign?</h1>
                            <p className='new-campaign-creation-mode-description'>
                                Choose to craft every detail yourself, or let AI analyze your profile and generate a data-backed strategy.
                            </p>
                        </div>
                    </div>

                    <div className="new-campaign-creation-mode-cards">
                        <button
                            type="button"
                            className="new-campaign-creation-card"
                            onClick={handleManualBuild}
                        >
                            <div className="new-campaign-creation-card__icon" aria-hidden="true">
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="11.9167" y="8.25" width="20.1667" height="27.5" rx="5.5" stroke="#26345D" strokeWidth="2.75" />
                                    <path d="M16.5 14.6667H27.5" stroke="#26345D" strokeWidth="2.75" strokeLinecap="round" />
                                    <path d="M16.5 20.1667H22" stroke="#26345D" strokeWidth="2.75" strokeLinecap="round" />
                                    <path d="M16.5 25.6667H19.25" stroke="#26345D" strokeWidth="2.75" strokeLinecap="round" />
                                    <path d="M27.5 8.25V19.25" stroke="#26345D" strokeWidth="2.75" strokeLinecap="round" />
                                    <path d="M32.0833 14.6667H22.9167" stroke="#26345D" strokeWidth="2.75" strokeLinecap="round" />
                                </svg>
                            </div>

                            <div className="new-campaign-creation-card__content">
                                <div className="new-campaign-creation-card__copy">
                                    <h2 className="new-campaign-creation-card__title">Build Manually</h2>
                                    <p className="new-campaign-creation-card__description">
                                        Full control. Set your own audience, creators, brief, and every campaign detail from scratch.
                                    </p>
                                </div>

                                <span className="new-campaign-creation-card__eyebrow">For experienced marketers</span>
                            </div>
                        </button>

                        <button
                            type="button"
                            className="new-campaign-creation-card new-campaign-creation-card--ai"
                            onClick={handleAiBuild}
                        >
                            <div className="new-campaign-creation-card__icon" aria-hidden="true">
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.9014 8.73047L20.4477 13.5523C20.8919 14.9377 21.9783 16.024 23.3636 16.4683L28.1854 18.0146L23.3636 19.5609C21.9783 20.0051 20.8919 21.0915 20.4477 22.4769L18.9014 27.2987L17.3551 22.4769C16.9108 21.0915 15.8245 20.0051 14.4391 19.5609L9.61731 18.0146L14.4391 16.4683C15.8245 16.024 16.9108 14.9377 17.3551 13.5523L18.9014 8.73047Z" fill="#FF5A69" />
                                    <path d="M31.271 18.9316L32.0612 21.3944C32.3071 22.1607 32.9079 22.7616 33.6743 23.0075L36.137 23.7977L33.6743 24.5879C32.9079 24.8337 32.3071 25.4346 32.0612 26.2009L31.271 28.6637L30.4808 26.2009C30.235 25.4346 29.6341 24.8337 28.8678 24.5879L26.405 23.7977L28.8678 23.0075C29.6341 22.7616 30.235 22.1607 30.4808 21.3944L31.271 18.9316Z" fill="#FF5A69" />
                                </svg>
                            </div>

                            <div className="new-campaign-creation-card__content">
                                <div className="new-campaign-creation-card__copy">
                                    <h2 className="new-campaign-creation-card__title">Build with AI</h2>
                                    <p className="new-campaign-creation-card__description">
                                        AI analyzes your brand profile and generates data-backed strategies with pre-built campaigns.
                                    </p>
                                </div>

                                <span className="new-campaign-creation-card__eyebrow">Smart · Fast · Strategic</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateCampaign